import * as React from 'react';
import classNames from 'classnames';

import * as style from './TableRow.css';

export interface ITableRowProps {
  fullWidth?: boolean;
  hover?: boolean;
}

export const TableRowComponent = React.forwardRef<HTMLTableRowElement, React.PropsWithChildren<ITableRowProps>>(
  (props, ref) => {
    const { children, hover } = props;

    return (
      <tr ref={ref} className={classNames(style['row'], hover && style['row--hovered'])}>
        {children}
      </tr>
    );
  },
);

TableRowComponent.displayName = 'TableRowComponent';

export const TableRow = React.memo(TableRowComponent);
